import React from 'react';
import { Tooltip } from 'antd';
import './style.scss';

const ProductCategoryLabel = ({
  categoryPath = [],
  categoryName = '',
  containerStyle = { width: 'fit-content' },
}) => (
  <div style={containerStyle}>
    {categoryPath?.length > 0 && (
      <Tooltip
        overlay={(
          <div
            style={{
              color: 'rgb(0, 0, 0)',
              fontSize: '12px',
              fontWeight: '500',
              padding: '2px',
            }}
          >
            {categoryPath?.join(' / ')}
          </div>
        )}
        color="rgb(234, 242, 254)"
        overlayStyle={{ zIndex: 9999 }}
      >
        <div
          className="product_category_label"
          style={{ backgroundColor: '#3aa5a6' }}
        >
          {`.../${categoryName}`}
        </div>
      </Tooltip>
    )}
  </div>
);

export default ProductCategoryLabel;
